import { render, staticRenderFns } from "./Wap_YSY002_Step3.vue?vue&type=template&id=0945bd65&scoped=true&"
import script from "./Wap_YSY002_Step3.vue?vue&type=script&lang=js&"
export * from "./Wap_YSY002_Step3.vue?vue&type=script&lang=js&"
import style0 from "./Wap_YSY002_Step3.vue?vue&type=style&index=0&id=0945bd65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945bd65",
  null
  
)

export default component.exports